var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "c-card",
        { staticClass: "cardClassDetailForm", attrs: { title: "LBL0002876" } },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  !_vm.checkAppr
                    ? [
                        _c(
                          "font",
                          {
                            staticClass: "text-negative",
                            staticStyle: {
                              "font-size": "0.9em",
                              "font-weight": "500",
                              "margin-right": "10px",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$message("MSG0000864")) + " "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _c("c-update-btn", {
                    attrs: {
                      name: "updateBtn",
                      data: _vm.param.planUpdateBtnData,
                      btnEditable: _vm.btnEditable,
                      flagCondition: _vm.flagCondition,
                    },
                    on: { back: _vm.back },
                  }),
                  _c("c-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.editable &&
                          _vm.param.eduEducationId &&
                          !_vm.disabled &&
                          _vm.checkAppr &&
                          _vm.educationInfo.documentStatusCd == "ESC000001",
                        expression:
                          "editable&&param.eduEducationId&&!disabled&&checkAppr&&educationInfo.documentStatusCd=='ESC000001'",
                      },
                    ],
                    attrs: {
                      label: "LBLREMOVE",
                      editable: _vm.editable,
                      icon: "delete_forever",
                    },
                    on: { btnClicked: _vm.remove },
                  }),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          url: _vm.saveUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.educationInfo,
                          mappingType: _vm.saveType,
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveEducation,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.educationInfo.eduEducationId &&
                          _vm.educationInfo.documentStatusCd == "ESC000001",
                        expression:
                          "editable&&!disabled&&educationInfo.eduEducationId&&educationInfo.documentStatusCd=='ESC000001'",
                      },
                    ],
                    attrs: {
                      showLoading: false,
                      icon: "check",
                      label: "LBLCOMPLETE",
                      isSubmit: _vm.isComplete,
                      url: _vm.completeUrl,
                      param: _vm.educationInfo,
                      mappingType: "PUT",
                    },
                    on: {
                      beforeAction: function ($event) {
                        return _vm.planComplete("COMPLETE")
                      },
                      btnCallback: _vm.planCompleteCallback,
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    afterIcon: _vm.disabled
                      ? null
                      : [
                          {
                            name: "search",
                            click: true,
                            callbackName: "searchEduMaster",
                          },
                          {
                            name: "close",
                            click: true,
                            callbackName: "removeEduMaster",
                          },
                        ],
                    required: true,
                    readonly: true,
                    close: true,
                    editable: _vm.editable,
                    label: "교육과정",
                    name: "educationCourseName",
                  },
                  on: {
                    searchEduMaster: _vm.searchEduMaster,
                    removeEduMaster: _vm.removeEduMaster,
                  },
                  model: {
                    value: _vm.educationInfo.educationCourseName,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationCourseName", $$v)
                    },
                    expression: "educationInfo.educationCourseName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    type: "edit",
                    codeGroupCd: "EDU_KIND_FST_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "educationKindCdLarge",
                    label: "교육종류1",
                  },
                  model: {
                    value: _vm.educationInfo.educationKindCdLarge,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationKindCdLarge", $$v)
                    },
                    expression: "educationInfo.educationKindCdLarge",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    type: "edit",
                    codeGroupCd: "EDU_KIND_SEC_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "educationKindCdSmall",
                    label: "교육종류2",
                  },
                  model: {
                    value: _vm.educationInfo.educationKindCdSmall,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationKindCdSmall", $$v)
                    },
                    expression: "educationInfo.educationKindCdSmall",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    type: "edit",
                    codeGroupCd: "EDU_CLASS_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "educationTypeCd",
                    label: "교육구분",
                  },
                  model: {
                    value: _vm.educationInfo.educationTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationTypeCd", $$v)
                    },
                    expression: "educationInfo.educationTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1" },
              [
                _c("c-checkbox", {
                  attrs: {
                    disabled: true,
                    isFlag: true,
                    editable: _vm.editable,
                    type: "edit",
                    label: "법정교육여부",
                    name: "legalEducationFlag",
                  },
                  model: {
                    value: _vm.educationInfo.legalEducationFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "legalEducationFlag", $$v)
                    },
                    expression: "educationInfo.legalEducationFlag",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1" },
              [
                _c("c-select", {
                  attrs: {
                    editable: false,
                    type: "edit",
                    codeGroupCd: "EDU_CYCLE_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "educationCycle",
                    label: "법정교육주기",
                  },
                  model: {
                    value: _vm.educationInfo.educationCycle,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationCycle", $$v)
                    },
                    expression: "educationInfo.educationCycle",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-multi-select", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    isArray: false,
                    codeGroupCd: "RELATED_LAWS_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    label: "관련법규",
                    name: "relationLaws",
                    maxValues: "3",
                  },
                  model: {
                    value: _vm.educationInfo.relationLaws,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "relationLaws", $$v)
                    },
                    expression: "educationInfo.relationLaws",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    label: "주요 대상자",
                    name: "mainTargetAudience",
                  },
                  model: {
                    value: _vm.educationInfo.mainTargetAudience,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "mainTargetAudience", $$v)
                    },
                    expression: "educationInfo.mainTargetAudience",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" },
              [
                _c("c-textarea", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    rows: 1,
                    label: "학습목적",
                    name: "educationPurpose",
                  },
                  model: {
                    value: _vm.educationInfo.educationPurpose,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationPurpose", $$v)
                    },
                    expression: "educationInfo.educationPurpose",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm",
          attrs: { title: "교육계획 기본정보" },
        },
        [
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-text", {
                  attrs: {
                    required: "",
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    label: "교육명",
                    name: "educationName",
                  },
                  model: {
                    value: _vm.educationInfo.educationName,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationName", $$v)
                    },
                    expression: "educationInfo.educationName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    type: "edit",
                    name: "plantCd",
                  },
                  model: {
                    value: _vm.educationInfo.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "plantCd", $$v)
                    },
                    expression: "educationInfo.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-dept", {
                  attrs: {
                    editable: _vm.editable,
                    required: true,
                    disabled: _vm.disabled,
                    plantCd: _vm.educationInfo.plantCd,
                    data: _vm.educationInfo,
                    label: "주관부서",
                    name: "departmentDeptCd",
                  },
                  model: {
                    value: _vm.educationInfo.departmentDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "departmentDeptCd", $$v)
                    },
                    expression: "educationInfo.departmentDeptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1" },
              [
                _c("c-checkbox", {
                  attrs: {
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    isFlag: true,
                    label: "기간/일",
                    trueLabel: "기간",
                    falseLabel: "일",
                    name: "educationRangeFlag",
                  },
                  on: { datachange: _vm.datachange },
                  model: {
                    value: _vm.educationInfo.educationRangeFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationRangeFlag", $$v)
                    },
                    expression: "educationInfo.educationRangeFlag",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isDate,
                      expression: "isDate",
                    },
                  ],
                  attrs: {
                    required: _vm.isDate,
                    disabled: _vm.disabled || _vm.yearEduAppr,
                    editable: _vm.editable,
                    label: "교육기간",
                    range: true,
                    type: "date",
                    name: "educationPeriod",
                  },
                  on: { input: _vm.updateEduNamePeriod },
                  model: {
                    value: _vm.educationPeriod,
                    callback: function ($$v) {
                      _vm.educationPeriod = $$v
                    },
                    expression: "educationPeriod",
                  },
                }),
                _c("c-datepicker", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isDate,
                      expression: "!isDate",
                    },
                  ],
                  attrs: {
                    required: !_vm.isDate,
                    disabled: _vm.disabled || _vm.yearEduAppr,
                    editable: _vm.editable,
                    label: "교육일",
                    type: "date",
                    name: "educationDate",
                  },
                  on: { input: _vm.updateEduNameDate },
                  model: {
                    value: _vm.educationInfo.educationStartDate,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationStartDate", $$v)
                    },
                    expression: "educationInfo.educationStartDate",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    required: "",
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    label: "교육시간",
                    type: "time",
                    range: true,
                    minuteStep: 10,
                    name: "eduPlanTime",
                  },
                  on: { input: _vm.updateTime },
                  model: {
                    value: _vm.param.eduPlanTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.param, "eduPlanTime", $$v)
                    },
                    expression: "param.eduPlanTime",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    label: "교육장소",
                    name: "educationLocation",
                  },
                  model: {
                    value: _vm.educationInfo.educationLocation,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationLocation", $$v)
                    },
                    expression: "educationInfo.educationLocation",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-text", {
                  attrs: {
                    suffix: _vm.$label("LBL0002813"),
                    type: "number",
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    label: "예상교육비",
                    name: "executionBudget",
                  },
                  model: {
                    value: _vm.educationInfo.executionBudget,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "executionBudget", $$v)
                    },
                    expression: "educationInfo.executionBudget",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-risk-assess", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    label: "관련 3단계판단법",
                    name: "ramRiskAssessmentPlanId",
                  },
                  model: {
                    value: _vm.educationInfo.ramRiskAssessmentPlanId,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.educationInfo,
                        "ramRiskAssessmentPlanId",
                        $$v
                      )
                    },
                    expression: "educationInfo.ramRiskAssessmentPlanId",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    type: "edit",
                    comboItems: _vm.comboItems,
                    itemText: "codeName",
                    itemValue: "code",
                    itemDisable: "disable",
                    name: "educationMethodCd",
                    label: "교육방법",
                  },
                  on: { datachange: _vm.educationMethodChange },
                  model: {
                    value: _vm.educationInfo.educationMethodCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "educationMethodCd", $$v)
                    },
                    expression: "educationInfo.educationMethodCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    disabled:
                      _vm.disabled ||
                      _vm.educationInfo.educationMethodCd != "EMC999999",
                    editable: _vm.editable,
                    comboItems: _vm.educationVodItems,
                    type: "edit",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "vod",
                    label: "교육용 동영상",
                  },
                  model: {
                    value: _vm.educationInfo.vod,
                    callback: function ($$v) {
                      _vm.$set(_vm.educationInfo, "vod", $$v)
                    },
                    expression: "educationInfo.vod",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 attachs",
          },
          [
            _c("c-upload", {
              attrs: {
                attachInfo: _vm.attachEduPlanInfo,
                editable: _vm.editable && !_vm.disabled,
                label: "교육계획 관련 파일",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 attachs",
          },
          [
            _c("c-upload", {
              attrs: {
                attachInfo: _vm.attachEduCourseInfo,
                editable: false,
                label: "교육과정 관련 파일",
              },
              on: { files: _vm.files },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "row mt-3" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c(
              "c-table",
              {
                ref: "subjectTable",
                attrs: {
                  title: "교육내용",
                  columns: _vm.grid.columns,
                  gridHeight: _vm.userGrid.height,
                  data: _vm.educationInfo.eduSubjectList,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  hideBottom: true,
                  isFullScreen: false,
                  isExcelDown: false,
                  noDataLabel: "교육내용이 없습니다.",
                  editable: _vm.editable && !_vm.disabled,
                  rowKey: "subjectNo",
                  selection: "multiple",
                },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가",
                                showLoading: false,
                                icon: "add",
                              },
                              on: { btnClicked: _vm.addSubject },
                            })
                          : _vm._e(),
                        _vm.editable &&
                        !_vm.disabled &&
                        _vm.educationInfo.eduSubjectList.length > 0
                          ? _c("c-btn", {
                              attrs: {
                                label: "제외",
                                showLoading: false,
                                icon: "remove",
                              },
                              on: { btnClicked: _vm.removeSubject },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.educationInfo.eduSubjectList &&
                _vm.educationInfo.eduSubjectList.length > 0
                  ? _c(
                      "template",
                      { slot: "suffixTitle" },
                      [
                        _c(
                          "font",
                          {
                            staticClass: "text-negative",
                            staticStyle: {
                              "font-size": "0.8em",
                              "font-weight": "300",
                            },
                          },
                          [_vm._v(" ※ 총 교육소요시간 : ")]
                        ),
                        _c(
                          "q-chip",
                          {
                            staticClass: "q-ma-none customchipdept",
                            attrs: {
                              outline: "",
                              square: "",
                              color: "primary",
                              "text-color": "white",
                            },
                          },
                          [
                            [
                              _vm._v(
                                " " + _vm._s(_vm.formattedEducationTime) + " "
                              ),
                            ],
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c(
              "c-table",
              {
                ref: "userTable",
                attrs: {
                  title: "교육대상자 목록",
                  columns: _vm.userGrid.columns,
                  gridHeight: _vm.userGrid.height,
                  data: _vm.educationInfo.eduAttendeeList,
                  filtering: false,
                  isFullScreen: false,
                  columnSetting: false,
                  usePaging: false,
                  isExcelDown: false,
                  hideBottom: true,
                  editable: _vm.editable && !_vm.disabled,
                  noDataLabel: "교육 대상자가 없습니다.",
                  rowKey: "attendeesNo",
                  selection: "multiple",
                },
                scopedSlots: _vm._u([
                  {
                    key: "customArea",
                    fn: function ({ props, col }) {
                      return [
                        col.name === "attendeesDeptName"
                          ? [
                              props.row["inExTypeCd"] === "EX"
                                ? _c("c-text-column", {
                                    attrs: {
                                      editable: _vm.editable,
                                      props: props,
                                      col: col,
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      datachange1: function ($event) {
                                        return _vm.datachange1(props)
                                      },
                                    },
                                    model: {
                                      value: props.row["attendeesDeptName"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.row,
                                          "attendeesDeptName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "props.row['attendeesDeptName']",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.row["attendeesDeptName"]) +
                                        " "
                                    ),
                                  ]),
                            ]
                          : _vm._e(),
                        col.name === "attendeesPositionName"
                          ? [
                              props.row["inExTypeCd"] === "EX"
                                ? _c("c-text-column", {
                                    attrs: {
                                      editable: _vm.editable,
                                      props: props,
                                      col: col,
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      datachange1: function ($event) {
                                        return _vm.datachange1(props)
                                      },
                                    },
                                    model: {
                                      value: props.row["attendeesPositionName"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.row,
                                          "attendeesPositionName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "props.row['attendeesPositionName']",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          props.row["attendeesPositionName"]
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ]
                          : _vm._e(),
                        col.name === "attendeesName"
                          ? [
                              props.row["inExTypeCd"] === "EX"
                                ? _c("c-text-column", {
                                    attrs: {
                                      editable: _vm.editable,
                                      props: props,
                                      col: col,
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      datachange1: function ($event) {
                                        return _vm.datachange1(props)
                                      },
                                    },
                                    model: {
                                      value: props.row["attendeesName"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.row,
                                          "attendeesName",
                                          $$v
                                        )
                                      },
                                      expression: "props.row['attendeesName']",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.row["attendeesName"]) +
                                        " "
                                    ),
                                  ]),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addInUser },
                            })
                          : _vm._e(),
                        _vm.editable &&
                        !_vm.disabled &&
                        _vm.educationInfo.eduAttendeeList.length > 0
                          ? _c("c-btn", {
                              attrs: {
                                label: "제외",
                                showLoading: false,
                                icon: "remove",
                              },
                              on: { btnClicked: _vm.removeUser },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "template",
                  { slot: "suffixTitle" },
                  [
                    _c(
                      "font",
                      {
                        staticClass: "text-negative",
                        staticStyle: {
                          "font-size": "0.8em",
                          "font-weight": "300",
                        },
                      },
                      [_vm._v(" ※ 교육대상자 등록은 필수입니다. ")]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }